/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { BaseURL } from "../../components/Common";
import { Palette } from "../../AppConfig";
import * as APP from "../../redux_store/appState";
import * as CONFIG from "../../redux_store/configState";
import { addNewArea, deleteArea } from "../../redux_store/jobState";
import BSL_Button from "../../components/BSL_Button";
import { GetAreaDescription } from "../main_drawer/QuotePage";
import SettingsEthernetIcon from "@material-ui/icons/SettingsEthernet";
import BSL_Dialog from "../../components/BSL_Dialog";
import BSL_SlidingView from "../../components/BSL_SlidingView";
import BSL_DraggableSlider from "../../components/BSL_DraggableSlider";
import { BASIC_SPECS_SECTIONS } from "../../redux_store/jobState_Schemas";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { updateJobParameter } from "../../redux_store/jobState";
import { FormGroup } from "@mui/material";
import BSL_Switch from "../../components/BSL_Switch";

const useStyles = makeStyles((theme) => ({
    root: {
        background: theme.brand.FIELDERS ? "#F4F4F4" : "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        width: "100%",
        transition: "all 1s ease 0.5s",
    },
    navigator: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        transition: "all 1s ease 0.5s",
    },
    headerContainer: {
        color: Palette.Control.Grey,
        fontFamily: theme.typography.fontFamily,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-start",
        width: "100%",
        flexDirection: "column",
        padding: "0px 0px 10px 0px",
        paddingTop: "5px",
    },
    areaHeader: {
        color: theme.brand.LYSAGHT ? Palette.Lysaght.DarkGrey : Palette.Control.Grey,
        font: theme.brand.FIELDERS
            ? "200 13pt " + theme.typography.fontFamily
            : "600 18px " + theme.typography.fontFamily,
        overflow: "none",
        flex: "1 0 100%",
        textAlign: "start",
        paddingLeft: "16px",
        textTransform: theme.brand.LYSAGHT ? "uppercase" : "capitalize",
    },
}));

export default function AreaSelector(props) {
    const classes = useStyles({ FIELDERS: window.FIELDERS });
    const dispatch = useDispatch();
    const { selectedAreaIndex, showHeader = true } = props;
    const AreaSpecifications = useSelector((state) => state.job.AreaSpecifications);
    const job = useSelector((state) => state.job);
    const deckMode = job?.DesignParameters?.DeckMode === 1;
    const carportMode = job?.DesignParameters?.CarportMode === 1;
    const OrderStatus = useSelector((state) => state.job?.OrderStatus);
    const UNLOCKED = useSelector((state) => state.app?.designer.UNLOCKED);
    const locked = (OrderStatus === "PENDING" || job?.App?.Locked) && !UNLOCKED;
    const DRAWER_TOOLSET_EXPANDED = props.page;
    let index = Math.trunc(selectedAreaIndex);

    if (index >= AreaSpecifications.length) index = AreaSpecifications.length - 1;

    const selectedArea = AreaSpecifications[index];
    let headers = [];

    AreaSpecifications.map((area, index) => {
        if (carportMode) {
            headers.push(
                <>
                    <div className={classes.areaHeader}>{GetAreaDescription(area, false)}</div>
                    <div className={classes.areaHeader} style={{ fontSize: "12px" }}>
                        {AreaSpecifications[index]?.SHAPE?.DesignTemplateName || ""}
                    </div>
                </>
            );
        } else {
            headers.push(
                <div key={index} value={index} index={index} className={classes.areaHeader}>
                    {"Area " +
                        (index + 1) +
                        " - " +
                        GetAreaDescription(area, false).replace("Verandah", "").replace("Roof", "")}
                </div>
            );
        }

        if (DRAWER_TOOLSET_EXPANDED === APP.SHAPE_TOOL && !carportMode) {
            headers.push(
                <div key={index + 0.5} value={index + 0.5} index={index + 0.5} className={classes.areaHeader}>
                    {
                        <>
                            Join {index + 1 + " "}{" "}
                            <SettingsEthernetIcon
                                style={{
                                    height: "18px",
                                    verticalAlign: "text-top",
                                }}
                            />{" "}
                            {" " +
                                (index + 2) +
                                " (" +
                                area.SHAPE.AREAJOIN.JoinType.replace("Offset", "End Join") +
                                ")"}
                        </>
                    }
                </div>
            );
        }
    });

    const [openDialog, setOpenDialog] = React.useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
    const switchConfigs = [
        { label: "Roof Type (Default Flat)", name: "roofType", title: "Roof type i.e Gable, Flat" },
        { label: "Structure Shape", name: "areaShape", title: "Height, Width, Depth, etc" },
        { label: "Attachments", name: "areaAttachments", title: "All Attachments" },
        { label: "Roofsheeting", name: "areaRoofsheet" },
        { label: "Beams & Posts", name: "areaBeamPost" },
        { label: "Gutters & Downpipes", name: "areaGutterDownpipe" },
    ];

    const [areaSettings, setAreaSettings] = React.useState(
        switchConfigs.reduce((values, switchConfig) => {
            return { ...values, [switchConfig.name]: true };
        }, {})
    );

    const handleSwitchChange = (values) => {
        setAreaSettings(values);
    };

    const areaAddDialogSettings = () => (
        <FormGroup>
            <BSL_Switch switches={switchConfigs} onChange={handleSwitchChange} initialValues={areaSettings} />
        </FormGroup>
    );

    const areaDialogs = () => (
        <>
            <BSL_Dialog
                title={"Add New Area"}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                button2Text="Add to Start"
                button2Click={() => {
                    setOpenDialog(false);
                    dispatch(addNewArea(true, areaSettings));
                }}
                button1Text="Add to End"
                button1Click={() => {
                    setOpenDialog(false);
                    dispatch(addNewArea(false, areaSettings));
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: "whitesmoke",
                        padding: "10px",
                        borderRadius: "10px",
                    }}
                >
                    <span>Inherit settings</span>
                    {areaAddDialogSettings()}
                </div>
                Adding new area... choose which side
            </BSL_Dialog>
            <BSL_Dialog
                title={"Delete Area " + (index + 1)}
                open={openDeleteDialog}
                onClose={() => setOpenDeleteDialog(false)}
                button2Text="Delete this Area"
                button2Click={() => {
                    setOpenDeleteDialog(false);
                    dispatch(deleteArea(index));
                }}
                button1Text="Cancel"
                button1Click={() => {
                    setOpenDeleteDialog(false);
                }}
            >
                Delete Area {index + 1} - {GetAreaDescription(selectedArea, false)}?
            </BSL_Dialog>
        </>
    );

    let nav_style = {
        gap: "95px",
        paddingLeft: "95px",
    };
    if (props.page === "SHAPE_TOOL")
        nav_style = {
            gap: "176px",
            paddingLeft: "95px",
        };
    if (!props.multi_view)
        nav_style = {
            gap: "0px",
            paddingLeft: "0px",
            padding: "8px 0px",
        };

    if (!selectedArea) {
        return <></>;
    }

    return (
        <div className={classes.root} style={props.multi_view ? { width: "0%" } : {}}>
            <BSL_DraggableSlider>
                {AreaSpecifications &&
                    !carportMode &&
                    AreaSpecifications.map((area, index) => (
                        <React.Fragment>
                            <div key={`thumbnail-div-${index}`}>
                                <AreaThumbnail
                                    key={index}
                                    index={index}
                                    label={props.multi_view}
                                    selected={selectedAreaIndex === index}
                                    onChange={props.onChange}
                                />
                            </div>
                            <div key={`join-div-${index}`}>
                                {index < AreaSpecifications.length - 1 && (
                                    <AreaJoin
                                        key={index + 0.5}
                                        index={index + 0.5}
                                        selected={selectedAreaIndex === index + 0.5}
                                        onChange={props.onChange}
                                    />
                                )}
                            </div>
                        </React.Fragment>
                    ))}
            </BSL_DraggableSlider>
            {showHeader && (
                <div className={classes.headerContainer}>
                    {!carportMode && (
                        <BSL_SlidingView
                            index={
                                DRAWER_TOOLSET_EXPANDED === APP.SHAPE_TOOL
                                    ? selectedAreaIndex * 2
                                    : Math.floor(selectedAreaIndex)
                            }
                            style={{
                                transition: "all 1s ease 0s",
                                opacity: props.multi_view ? 0 : 1,
                            }}
                        >
                            {headers}
                        </BSL_SlidingView>
                    )}
                    {carportMode && (
                        <div
                            style={{
                                flexDirection: "column",
                            }}
                        >
                            {headers}
                        </div>
                    )}

                    {!deckMode && !carportMode && (
                        <>
                            <BSL_Button
                                style={{ marginRight: "8px", position: "absolute", right: "95px", border: "0px" }}
                                tight
                                secondary
                                disabled={locked}
                                label={<DeleteForeverIcon />}
                                onClick={() => {
                                    setOpenDeleteDialog(true);
                                    dispatch(updateJobParameter("BlockingToAttachedAcknowledgement", false));
                                }}
                            />
                            <BSL_Button
                                style={{ marginRight: "8px", position: "absolute", right: "10px" }}
                                tight
                                disabled={locked}
                                label="Add Area"
                                onClick={() => {
                                    setOpenDialog(true);
                                    dispatch(updateJobParameter("BlockingToAttachedAcknowledgement", false));
                                }}
                            />
                        </>
                    )}
                </div>
            )}
            {areaDialogs()}
        </div>
    );
}

const thumbStyles = makeStyles((fielders) => ({
    root: {
        height: "30px",
        width: "60px",
        minWidth: "20px",
        maxWidth: "80px",
        minHeight: "20px",
        maxHeight: "70px",
        background: "#FFFFFF",
        border: "1px solid #6B8799",
        backgroundImage: "none",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "&:hover": {
            outline: "2px dotted #002D6280",
            outlineOffset: "2px",
            cursor: "pointer",
        },
        font: "12px 'Univers45', sans-serif",
        color: Palette.Control.Grey,
        margin: "0px 5px",
    },
    text: {
        backgroundColor: "#FFFFFF",
    },
    selected: (fielders) => ({
        backgroundColor: fielders ? Palette.Control.FieldersDarkBlue : Palette.Lysaght.DarkBlue,
        color: "white",
    }),
    areaHeader: {
        color: Palette.Control.Grey,
        font: "13pt 'Univers45', sans-serif",
        flex: 1,
        textAlign: "start",
        paddingLeft: "0px",
        position: "absolute",
        marginTop: "66px",
        transition: "opacity 1s ease 1s",
    },
    headerSelected: (fielders) => ({
        backgroundColor: fielders ? Palette.Control.FieldersDarkBlue : Palette.Lysaght.DarkBlue,
    }),
}));

function AreaThumbnail(props) {
    const classes = thumbStyles(window.FIELDERS);
    const AreaSpecifications = useSelector((state) => state.job.AreaSpecifications);
    const selectedArea = AreaSpecifications[props.index];
    const changeArea = () => {
        if (props.onChange) props.onChange(props.index);
    };
    let header_text =
        "Area " +
        (props.index + 1) +
        " - " +
        GetAreaDescription(selectedArea, false).replace("Verandah", "").replace("Roof", "");

    let length = selectedArea[BASIC_SPECS_SECTIONS.SHAPE].Length;
    let depth = selectedArea[BASIC_SPECS_SECTIONS.SHAPE].Depth;

    let background = 'url("' + BaseURL("images/thumb_flat_front.svg") + '")';
    let background_size = "contain";
    let top_margin = "0px";
    let left_margin = "0px";

    if (selectedArea[BASIC_SPECS_SECTIONS.SHAPE].RoofPitch < 0) {
        background = 'url("' + BaseURL("images/thumb_flat_back.svg") + '")';
    } else if (
        selectedArea[BASIC_SPECS_SECTIONS.SHAPE].DesignSubType === "Type 3" &&
        selectedArea[BASIC_SPECS_SECTIONS.SHAPE].SheetDirection === "Left"
    ) {
        background = 'url("' + BaseURL("images/thumb_flat_left.svg") + '")';
    } else if (
        selectedArea[BASIC_SPECS_SECTIONS.SHAPE].DesignSubType === "Type 3" &&
        selectedArea[BASIC_SPECS_SECTIONS.SHAPE].SheetDirection === "Right"
    ) {
        background = 'url("' + BaseURL("images/thumb_flat_right.svg") + '")';
    } else if (
        selectedArea[BASIC_SPECS_SECTIONS.SHAPE].DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL ||
        selectedArea[BASIC_SPECS_SECTIONS.SHAPE].DesignType === CONFIG.DESIGN_TYPES.PITCHED
    ) {
        background = 'url("' + BaseURL("images/thumb_gable.svg") + '")';
        background_size = "cover";

        if (selectedArea[BASIC_SPECS_SECTIONS.SHAPE].RotateArea === 1) {
            background = 'url("' + BaseURL("images/thumb_gable_90.svg") + '")';
            length = selectedArea[BASIC_SPECS_SECTIONS.SHAPE].Depth;
            depth = selectedArea[BASIC_SPECS_SECTIONS.SHAPE].Length;
        }
    } else if (selectedArea[BASIC_SPECS_SECTIONS.SHAPE].DesignType === CONFIG.DESIGN_TYPES.DECK) {
        let holder = depth;
        depth = length;
        length = holder;
    }

    return (
        <div
            key={props.index}
            className={classes.root + (props.selected ? " " + classes.selected : " ")}
            onClick={changeArea}
            style={{
                width: length / 100 + "px",
                height: depth / 100 + "px",
                backgroundImage: background,
                backgroundSize: background_size,
            }}
        >
            <div
                className={classes.text + (props.selected ? " " + classes.selected : " ")}
                style={{ marginTop: top_margin, marginLeft: left_margin }}
            >
                {props.index + 1}
            </div>
            <div
                className={classes.areaHeader + (props.selected ? " " + classes.headerSelected : " ")}
                style={{ opacity: props.label ? 1 : 0 }}
            >
                {header_text}
            </div>
        </div>
    );
}

const joinStyles = makeStyles({
    root: {
        width: "30px",
        height: "40px",
        minHeight: "20px",
        maxHeight: "70px",
        margin: "1px -1px 0px -1px",
        zIndex: "10",
        display: "flex",
        justifyContent: "center",
        margin: "0px 3px",
        "&:hover": {
            outline: "2px dotted #002D6280",
            outlineOffset: "2px",
        },
    },
    bar: {
        background: Palette.Control.Grey,
        height: "40px",
        width: "4px",
    },
    selected: {
        background: Palette.Control.FieldersDarkBlue,
    },
    areaHeader: {
        color: Palette.Control.Grey,
        font: "13pt 'Univers45', sans-serif",
        flex: 1,
        textAlign: "start",
        paddingLeft: "16px",
    },
});

function AreaJoin(props) {
    const classes = joinStyles();
    const AreaSpecifications = useSelector((state) => state.job.AreaSpecifications);
    const selectedArea = AreaSpecifications[Math.trunc(props.index)];
    const selectedAreaNext = AreaSpecifications[Math.trunc(props.index + 1)];
    const changeArea = () => {
        if (props.onChange) props.onChange(props.index, APP.SHAPE_TOOL);
    };
    let header_text = (
        <>
            Join {props.index + 1 + " "}{" "}
            <SettingsEthernetIcon
                style={{
                    height: "18px",
                    verticalAlign: "text-top",
                }}
            />{" "}
            {" " + (props.index + 2) + " (" + selectedArea.SHAPE.AREAJOIN.JoinType.replace("Offset", "End Join") + ")"}
        </>
    );

    let length = selectedArea[BASIC_SPECS_SECTIONS.SHAPE].Depth;

    if (selectedArea[BASIC_SPECS_SECTIONS.SHAPE].RotateArea === 1) {
        length = selectedArea[BASIC_SPECS_SECTIONS.SHAPE].Length;
    }

    let length_next = selectedAreaNext[BASIC_SPECS_SECTIONS.SHAPE].Depth;

    if (selectedAreaNext[BASIC_SPECS_SECTIONS.SHAPE].RotateArea === 1) {
        length_next = selectedAreaNext[BASIC_SPECS_SECTIONS.SHAPE].Length;
    }

    let this_length = length > length_next ? length : length_next;

    return (
        <div
            key={props.index}
            className={classes.root}
            onClick={changeArea}
            style={{ height: this_length / 100 + "px", alignItems: "center" }}
        >
            <div>
                <img
                    style={{
                        width: "25px",
                        verticalAlign: "middle",
                    }}
                    draggable="false"
                    src={props.selected ? BaseURL("/images/separator_selected.png") : BaseURL("/images/separator.png")}
                />
            </div>
            {props.label && <div className={classes.areaHeader}>{header_text}</div>}
        </div>
    );
}
